import { RegisterFactories } from './product/ProductViewModelSpecificFactories.js';

//*****
// START Export all used classes (we need to export anything that is used in our Razor views)
//*****

// Product:
//export { PixiDrawingEngine } from './product/Pixi/PixiDrawingEngine.js'; // Not used anymore
export { HtmlDrawingEngine } from './product/HtmlDrawing/HtmlDrawingEngine.js'; //  Cart.cshtml, CheckoutReviewAndPay.cshtml, OrderTracking.cshtml, and Product.cshtml via ProductHelpers.cshtml
export { BabylonDrawingEngine } from './product/Babylon/BabylonDrawingEngine.js'; // Cart.cshtml, CheckoutReviewAndPay.cshtml, OrderTracking.cshtml, and Product.cshtml via ProductHelpers.cshtml
export { ProductPageViewModel } from './product/ProductPageViewModel.js'; // Product.cshtml

//*****
// END Export all used classes
//*****

export class ProductApp {
  constructor(config) {
    // Register product view model factories:
    RegisterFactories(); // In ProductViewModelSpecificFactories.js
  }
}
